import { render, staticRenderFns } from "./BoundMobile.vue?vue&type=template&id=0cd4337c&"
import script from "./BoundMobile.vue?vue&type=script&lang=js&"
export * from "./BoundMobile.vue?vue&type=script&lang=js&"
import style0 from "./BoundMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports